/**
 * Collect every message string from a DRF error body.
 *
 * DRF nests field errors arbitrarily, e.g. {"user": {"password": ["..."]}},
 * {"organization": ["..."]}, {"detail": "..."} or a top-level ["..."].
 * Toast libraries drop arrays/objects, so callers need plain strings.
 */
export const flattenErrorMessages = (data: unknown): string[] => {
  if (typeof data === "string") {
    return data ? [data] : [];
  }
  if (Array.isArray(data)) {
    return data.flatMap(flattenErrorMessages);
  }
  if (data && typeof data === "object") {
    return Object.values(data).flatMap(flattenErrorMessages);
  }
  return [];
};
